// removed by extract-text-webpack-plugin
module.exports = {"contact-S":"contact-S","contact-business":"contact-business","contact-S-title":"contact-S-title","contact-S-wrapper":"contact-S-wrapper","contact-S-right-forrm":"contact-S-right-forrm","contact-S-left-address":"contact-S-left-address","contact-S-map":"contact-S-map","map":"map","contact-S-address":"contact-S-address","contact-S-address-content":"contact-S-address-content","contact-S-address-des":"contact-S-address-des","contact-S-address-icon":"contact-S-address-icon","contact-S-address-des-wrap":"contact-S-address-des-wrap","strong-content":"strong-content"};


//////////////////
// WEBPACK FOOTER
// ./components/contact/style.scss
// module id = ./components/contact/style.scss
// module chunks = 0